import React, { useEffect, useState } from 'react';
import { ExternalData } from "./externalData";
import { RetailersProxy } from "../../../../services/catalogServiceAPI/retailersProxy";
import { Button, List } from 'antd';
import { PlusOutlined, DeleteOutlined } from '@ant-design/icons';

export const ExternalDataList = ({ variantStore }) => {
    const [retailers, setRetailers] = useState(null);

    useEffect(() => {
        (new RetailersProxy()).list().then(setRetailers);
    }, []);

    if (retailers === null) {
        return <span>Loading retailers…</span>;
    }

    const getRetailerName = (id) => retailers.find((a) => a.id === id)?.name ?? id;

    return (
        <div style={{ marginTop: 8 }}>
            <div style={{ marginBottom: 6 }}>
                <Button
                    size="small"
                    icon={<PlusOutlined />}
                    onClick={variantStore.addExternalData}
                >
                    Add
                </Button>
            </div>

            {variantStore?.externalData.length > 0 && (
                <List
                    size="small"
                    dataSource={variantStore.externalData}
                    renderItem={(data, i) => (
                        <List.Item
                            key={i}
                            extra={
                                <Button
                                    size="small"
                                    danger
                                    type="text"
                                    icon={<DeleteOutlined />}
                                    onClick={() => variantStore.removeExternalData(data.url)}
                                >
                                    {data.retailerId ? getRetailerName(data.retailerId) : 'Remove'}
                                </Button>
                            }
                            style={{ padding: '4px 0' }}
                        >
                            <ExternalData externalDataStore={data} retailers={retailers} />
                        </List.Item>
                    )}
                />
            )}
        </div>
    );
};
